export default {"src":"/_next/static/media/qrcode.2b4ef851.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};